export default {
  BASE_URL: '/category',
  api: [
    {
      name: 'delete',
      method: 'GET',
      desc: '删除分类',
      path: '/remove/category/{id}',
      params: {
        id: ''
      }
    },
    {
      name: 'checkName',
      method: 'GET',
      desc: '校验分类名称是否重复',
      path: 'validateCategoryName',
      params: {
        bizId: '',
        parentId: '',
        categoryName: '',
        id: ''
      }
    },
    {
      name: 'selectNextSortNum',
      method: 'GET',
      desc: '新增时获取排序号',
      path: '/next/sortNum',
      params: {
        bizId: '',
        id: '' // 上级类目id
      }
    },
    {
      name: 'floorCate',
      method: 'GET',
      desc: '获取楼层分类',
      path: '/floor',
      params: {
        parentId: '' // 上级类目id
      }
    },
    {
      name: 'saleCate',
      method: 'GET',
      desc: '获取分类',
      path: '/sale/Category',
      params: {
        parentId: '' // 上级类目id
      }
    },
    {
      name: 'getAllCatas',
      method: 'GET',
      desc: '根据父级id获取分类',
      path: '/getAllCatas',
      params: {
        parentId: '' // 上级类目id
      }
    },
    {
      name: 'getCatasCondition',
      method: 'GET',
      desc: '获取集采设置的分类',
      path: '/getCatasCondition'
    },
    {
      name: 'attrLevel',
      method: 'GET',
      desc: '商品属性分类',
      path: '/all/level'
    },
    {
      name: 'getSecondProp',
      method: 'GET',
      desc: '获取二级商品属性',
      path: '/sale/Category',
      params: {
        levelCode: 3 // 上级类目id
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/pm/category.js